import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "item", "destroy"]

  add(event) {
    event.preventDefault()
    const key = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    this.containerTarget.insertAdjacentHTML(
      "beforeend",
      this.templateTarget.innerHTML.replaceAll("NEW_RECORD", key)
    )
  }

  remove(event) {
    event.preventDefault()
    const item = event.currentTarget.closest("[data-simple-order-items-target='item']")
    const destroy = item.querySelector("[data-simple-order-items-target='destroy']")

    if (destroy) {
      destroy.value = "1"
      item.classList.add("d-none")
    } else {
      item.remove()
    }
  }
}
